export default __webpack_public_path__ + "static/media/IMG_9230 copie.ed265db5.jpg";